import Api from '../../api/Api'

const sertifikat = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    sertifikat: [],
    detail: {},
  },

  //mutations
  mutations: {
    SET_SERTIFIKAT(state, data) {
      state.sertifikat = data
    },
    SET_DETAIL(state, data) {
      state.detail = data
    },
  },

  //actions
  actions: {
    data({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/sertifikat/list-sertifikat?per_page=${param.per_page}&page=${param.page}&status=${param.status}&search=${param.search}&start=${param.start}&end=${param.end}`,
        )
          .then((response) => {
            commit('SET_SERTIFIKAT', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detail({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/sertifikat/detail/${param.id_aktifitas}`)
          .then((response) => {
            if (response.data.success) {
              commit('SET_DETAIL', response.data.data.detail)
            }

            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    generateSertifikat({}, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/sertifikat/generateSertifikat`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    generateSertifikatWorkshop({}, data) {
      console.log(data)
      return new Promise((resolve, reject) => {
        Api.post(`/sertifikat/generateSertifikatWorkshop`, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    generateJP({}, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/sertifikat/generateSertifikatJP`, data, {})
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    downloadWebinar({}, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/sertifikat/downloadSertifikatWebinar?id_aktifitas=${data.id}&index=${data.index}`,
          {
            responseType: 'blob',
          },
        )
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getSertifikat(state) {
      return state.sertifikat
    },
    getDetail(state) {
      return state.detail
    },
  },
}

export default sertifikat
